
import WDCardList from './wd-card-list';
import WDListForm from '../lists/wd-list-form';

export default class WDCardListForm extends WDCardList
{
	#list;

	constructor(cfg)
	{
		super(cfg).classList.add('wd-card-list', 'wd-card-list-form');
	};

	/**
	 * Overrides parent buildList to use WDListForm
	 * @param {object} cfg 
	 */
	buildList(cfg)
	{
		if (this.#list) this.#list.remove();

		this.#list = new WDListForm(cfg);
		this.#list.classList.add('scrollable');
		this.body.append(this.#list);

		//I can't decide on naming yet
		if (cfg?.filters) this.buildFilters(cfg.filters);
	};

};

customElements.define('wd-card-list-form', WDCardListForm);
